import { appId, SubscribeType } from '@/constants';
import { getUrlParam } from '@/utils';
import { getClientId, getIncomeSource, isAppStorePay } from '@/utils/vip';
import request from '../../utils/request';
import {
  FetchUserTokenParams,
  // UpgradeResponse,
  FetchUserTokenResponse,
  FetchUserInfoResponse,
  GetAccesTokenByCookieResponse,
  UserInfoResponse,
  TeamInfoResponse,
  MemberInfoResponse,
  FetchZhankuManagerResponse,
  FetchRebateCodeResponse,
} from './index.d';

/**
 * 会员升级通知
 */
// export const upgradeNotify = async function () {
//   return await request<UpgradeResponse>('/api/pro/vip_combination_notify', {
//     method: 'GET',
//   });
// };

/**
 * 获取用户token
 * code换token
 * @param params
 * @returns
 */

export const fetchUserToken = async (params: FetchUserTokenParams) => {
  return await request<FetchUserTokenResponse>(
    `${process.env.REACT_APP_API_PRO_HOST}/api/v1/user/token`,
    {
      method: 'GET',
      withCredentials: true,
      params: Object.assign({}, params, {
        app_id: appId,
        gid: window.localStorage.getItem('GID') || '123',
      }),
    }
  );
};

/**
 * 获取用户token
 * 透传cookie返回token
 * @param params
 * @returns
 */

export const getAccesTokenByCookie = async () => {
  return await request<GetAccesTokenByCookieResponse>(
    `${process.env.REACT_APP_API_ACCOUNT_HOST}/oauth/get_access_token_by_cookie`,
    {
      method: 'GET',
    }
  );
};

/**
 * 获取用户和会员权益等信息
 * @param params
 * @returns
 * https://api-mock.meitu-int.com/project/2110/interface/api/116813
 */

export const fetchUserInfo = async () => {
  return await request<FetchUserInfoResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/user/info`,
    {
      method: 'GET',
      params: {
        gid: window.localStorage.getItem('GID') || '123',
        with_login_method: 1,
        vip_group:
          getUrlParam('subscribe_type') === SubscribeType.MEIDOUPACKAGE ? 'aicp_group' : '', // 商拍美豆套餐订阅特别需要透传的标识
        client_id: getClientId(),
        with_identification: 1,
        // 需要返回用户购买的商品是续期/非续期,商品周期信息
        with_contract: 1,
      },
    }
  );
};

/**
 * 获取海洛顾问信息
 * @returns
 * https://api-mock.meitu-int.com/project/2110/interface/api/175607
 */
export const fetchZhankuManager = () => {
  return request<FetchZhankuManagerResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/zhanku/manager`,
    {
      method: 'GET',
      params: {},
    }
  );
};

/**
 * 接口 [获取用户跨应用会员信息(H5)↗](/h5/user/user_info.json)，直接调用订阅中台接口
 * @docs: https://api-mock.meitu-int.com/project/1698/interface/api/135011
 */
export const getUserInfoFromPlatform = async function () {
  return await request<UserInfoResponse>(
    `${process.env.REACT_APP_API_SUB_HOST}/h5/user/user_info.json`,
    {
      method: 'GET',
      params: {
        app_id: '6829803307012000000',
      },
      headers: {
        'access-token': window.localStorage.getItem('access_token') as string,
      },
    }
  );
};

/**
 * 接口 [[团队]获取团队信息↗](/enterprise/team/info)
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/146056
 */
export const fetchTeamInfo = async function () {
  return await request<TeamInfoResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/enterprise/team/info`,
    {
      method: 'GET',
    }
  );
};

/**
 * 接口 [[团队]获取我的成员信息↗](/enterprise/team/member_info)
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/149033
 */
export const fetchMemberInfo = async function () {
  return await request<MemberInfoResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/enterprise/team/member_info`,
    {
      method: 'GET',
    }
  );
};

/**
 * 接口 [获取商品组标识↗](/v1/home/get_init_data)
 * @docs:
 */
export const getInitData = async () => {
  return await request<FetchUserInfoResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/v1/home/get_init_data`,
    {
      method: 'GET',
      params: {
        source: getIncomeSource(),
        iap: isAppStorePay() ? 1 : 0,
      },
    }
  );
};

/**
 * 接口 [获取团队版分销码↗](/v1/home/get_init_data)
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/186076
 */
export const getRebateCode = async () => {
  return await request<FetchRebateCodeResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/enterprise/team/get_rebate_code`,
    {
      method: 'GET',
    }
  );
};

/**
 * 接口 [获取个人版的分销码↗](/v1/home/get_init_data)
 * @docs: https://api-mock.meitu-int.com/project/2110/interface/api/186076
 */
export const getSubPromoteRebateCode = async () => {
  return await request<FetchRebateCodeResponse>(
    `${process.env.REACT_APP_API_WEBAPI_HOST}/sub_promote/get_rebate_code`,
    {
      method: 'GET',
    }
  );
};
